import { createStyles } from '@material-ui/core';
import Colours from 'bz-core-controls/styles/colours';

const styles = createStyles({
  actionsContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%'
  },
  statusLabel: {
    position: 'absolute',
    color: Colours.red700,
    display: 'flex',
    alignItems: 'center',
    height: '20px',
    padding: '2px 4px',
    border: `2px solid ${Colours.red700}`,
    fontWeight: 800,
    fontSize: '11px',
    textTransform: 'uppercase',
    background: '#fff !important',
    cursor: 'default',
    justifySelf: 'right',
    top: '10px',
    right: '10px'
  },
  active: {
    color: Colours.green700,
    borderColor: Colours.green700
  },
  expired: {
    color: Colours.blue700,
    borderColor: Colours.blue700
  }
});

export default styles;
